import { render } from "./CreatorsLine.vue?vue&type=template&id=5920bb9c"
import script from "./CreatorsLine.vue?vue&type=script&lang=js"
export * from "./CreatorsLine.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__